import axiosInstance from "./axiosInstance.ts";

export const createOtp = (phoneNumber: string) => {
   return axiosInstance.post("/otp/create", {
        "recipient" : phoneNumber
    });
}

export const verifyOtp = (phoneNumber: string,otp: string) => {
    return  axiosInstance.post("/otp/verify", {
        "recipient" : phoneNumber,
        "code": otp
    });
}
